module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Layout', [_c('SubHeader', {
    attrs: {
      "slot": "sub-header",
      "title": _vm.$t('common.detail'),
      "isBackground": false
    },
    slot: "sub-header"
  }, [_c('div', {
    staticClass: "content-report-container",
    attrs: {
      "slot": "sub-header-tab"
    },
    on: {
      "click": function($event) {
        _vm.reportContentModalIsShown = true
      }
    },
    slot: "sub-header-tab"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/ic-more-active.svg",
      "alt": "content-report-icon"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "video-view",
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [(_vm.busy) ? _c('LoadingBounce') : [_c('Lvideo', {
    staticClass: "video",
    attrs: {
      "videoId": _vm.videoId,
      "isVideoAutoState": _vm.isVideoAutoState,
      "isCourseCard": _vm.isCourseCard,
      "courseId": _vm.courseId,
      "videoUrl": _vm.videoUrl,
      "nextVideoId": _vm.nextVideoId,
      "savedPreviewVideoLecture": _vm.savedPreviewVideoLecture
    },
    on: {
      "openPrimeModal": _vm.openPrimeModal
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "video-title"
  }, [_vm._v("\n        " + _vm._s(_vm.videoTitle) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "video-publisher-name"
  }, [_vm._v("\n        " + _vm._s(_vm.publisherName) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "video-subject"
  }, [_vm._v("\n        " + _vm._s(_vm.videoGrade) + "\n        " + _vm._s(_vm.videoSubjectName) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "video-view-count"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('common.view_count')) + " " + _vm._s(_vm.videoViewCount) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "video-like-count"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('common.like_up')) + " " + _vm._s(_vm.getToCommas(_vm.videoLikeCount)) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "video-description",
    domProps: {
      "innerHTML": _vm._s(_vm.videoDescription)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "video-created-date"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('common.created_date')) + " " + _vm._s(_vm.videoCreatedDate) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "video-actions"
  }, [_c('a', {
    class: [_vm.isLikeVideoLecture ? 'active' : ''],
    on: {
      "click": function($event) {
        return _vm.toggleLike()
      }
    }
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "src": ("/static/images/ic_post_light" + (_vm.isLikeVideoLecture ? '_active' : '_normal') + ".svg")
    }
  }), _vm._v("\n          " + _vm._s(_vm.$t('common.like_up')) + "\n        ")]), _vm._v(" "), _c('a', {
    class: [_vm.isBookmarkVideoLecture ? 'active' : ''],
    on: {
      "click": function($event) {
        return _vm.toggleBookmark()
      }
    }
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "src": ("/static/images/ic_bookmark" + (_vm.isBookmarkVideoLecture ? '_active' : '') + ".svg")
    }
  }), _vm._v("\n          " + _vm._s(_vm.$t('common.bookmark')) + "\n        ")])]), _vm._v(" "), (_vm.isVideoCourse) ? _c('div', {
    staticClass: "video-course"
  }, [_c('CourseCard', {
    attrs: {
      "course": _vm.videoCourse,
      "isVideoCourse": true
    },
    on: {
      "click": function($event) {
        return _vm.viewCourse(_vm.videoCourse.id)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "video-relation"
  }, [_c('div', {
    staticClass: "row align-items-center header"
  }, [_c('div', {
    staticClass: "col-8 title"
  }, [_vm._v(_vm._s(_vm.isCourseCard ? _vm.$t('course.video_lecture') : _vm.$t('video_lecture.relation_video_lecture')))]), _vm._v(" "), _c('div', {
    staticClass: "col-4 action"
  }, [_c('ToggleSwitch', {
    on: {
      "change": _vm.change
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row px-8"
  }, [_vm._l((_vm.videoLectures), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "col-lg-6 col-md-6 col-sm-12 px-6 mb-2"
    }, [_c('LeftImageCard', {
      attrs: {
        "videoLecture": item,
        "isCurrentCard": _vm.isCurrentCard(item.id),
        "isCourseCard": _vm.isCourseCard,
        "courseId": _vm.courseId
      }
    })], 1)
  }), _vm._v(" "), _c('InfiniteLoading', {
    staticClass: "w-100",
    on: {
      "infinite": _vm.infiniteHandler
    }
  }, [_c('div', {
    attrs: {
      "slot": "spinner"
    },
    slot: "spinner"
  }, [_c('LoadingBounce')], 1), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "no-results"
    },
    slot: "no-results"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "no-more"
    },
    slot: "no-more"
  })])], 2)])], _vm._v(" "), (_vm.isSnackBar) ? _c('PrimeSnackBar', {
    on: {
      "okSnackBar": function($event) {
        return _vm.okSnackBar()
      },
      "closeSnackBar": function($event) {
        return _vm.closeSnackBar()
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isPrmieModal) ? _c('CustomModal', {
    staticClass: "basic-modal no-header-modal",
    attrs: {
      "hide-header": true,
      "closeTitle": _vm.$t('prime.lecture_notice.cancel'),
      "okTitle": _vm.$t('prime.lecture_notice.confirm')
    },
    on: {
      "ok": function($event) {
        return _vm.okPrimeModal()
      },
      "cancel": function($event) {
        return _vm.closePrimeModal()
      }
    }
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('prime.lecture_notice.description'))
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.isLicenceModal) ? _c('LicenceModal', {
    on: {
      "ok": function($event) {
        _vm.isLicenceModal = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.reportContentModalIsShown && _vm.videoLecture) ? _c('ReportContentModal', {
    staticClass: "content-report-modal",
    attrs: {
      "videoLecture": _vm.videoLecture
    },
    on: {
      "ok": function($event) {
        return _vm.onContentReportSent()
      },
      "cancel": function($event) {
        _vm.reportContentModalIsShown = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.contentReportSuccessModalIsShown) ? _c('CustomModal', {
    staticClass: "basic-modal no-header-modal hide-cancel-btn content-report-modal",
    attrs: {
      "id": "content-report-success-modal",
      "hide-header": true,
      "isCloseButton": false,
      "ok-title": _vm.$t('common.confirmation')
    },
    on: {
      "ok": function($event) {
        _vm.contentReportSuccessModalIsShown = false
      }
    }
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('common.error_report'))
    }
  })]) : _vm._e()], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-073d277e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/video-lecture/views/VideoLectureView.vue
// module id = 1551
// module chunks = 1